import React, { useEffect, useState } from 'react';
import { useDataLoader } from 'react-remote-data-hooks';
import api from '../../../../api';
import { ContainerLoader } from '../../../../components/loader';
import PermissionSelectionView from './PermissionSelectionView';

interface PermissionSelectionProps {
  default?: string[];
  onChange?: (permission: string[]) => void;
  heading?: React.ReactNode;
  disabled?: boolean;
}

const PermissionSelection: React.SFC<PermissionSelectionProps> = (props) => {
  const { onChange, heading } = props;
  const { data: permissions, loading, loaded } = useDataLoader(() =>
    api.role.getAllPermissions()
  );

  const [selectedItems, setSelectedItems] = useState(props.default || []);

  useEffect(() => {
    setSelectedItems(props.default || []);
  }, [props.default]);

  const onPermissionSelection = (
    permission: string | string[],
    selected: boolean
  ) => {
    let items = [...selectedItems];
    if (Array.isArray(permission)) {
      if (selected) {
        items.push(...permission);
      } else {
        items = selectedItems.filter((p) => !permission.includes(p));
      }
    } else if (selected) {
      items.push(permission);
    } else {
      items = selectedItems.filter((p) => p !== permission);
    }
    if (onChange) {
      onChange?.(items);
    }
  };

  if (loading || !loaded) {
    return <ContainerLoader></ContainerLoader>;
  }

  return (
    <PermissionSelectionView
      selectedPermissions={selectedItems}
      permissions={permissions}
      onPermissionSelection={onPermissionSelection}
      heading={heading}
      disabled={props.disabled}
    />
  );
};

export default PermissionSelection;
